jQuery.noConflict();
(function($) {
	$(document).ready(function(){
		$('.subpage-callout__link').hover(function(){
      var page = $(this);
      var landingPageTemplate = document.querySelector('.v-ta-callout');
      var image = page.find('.subpage-callout__image-wrap');

      if ($(this).parent().hasClass('subpage-callout__page--active')) {
        return;
      }

      if (image.css('display') === 'none') return;

      var blueOverlay = page.find('.subpage-callout__blue-overlay');
      var arrow = page.find('.subpage-callout__arrow');
      var title = page.find('.subpage-callout__title');

      var titles = $('.subpage-callout__title').map(function() {
        return $(this).outerHeight();
      }).get();

      var fullTitleHeight = Math.max.apply(null, titles);

      var images = $('.subpage-callout__image-wrap').map(function() {
        return $(this).outerHeight();
      }).get();

      var fullImageHeight = Math.max.apply(null, images);

      var imageOffTop = image.offset().top;
      var imageOffMiddle = imageOffTop + (image.outerHeight() / 2);
      var imageOffBottom = imageOffTop + image.outerHeight();
      var fullImageOffTop = imageOffMiddle - fullImageHeight / 2;
      var fullImageOffBottom = imageOffMiddle + fullImageHeight / 2;

      var titleOffTop = title.offset().top;
      var titleOffBottom = titleOffTop + title.outerHeight();
      var fullTitleOffBottom = titleOffTop + fullTitleHeight;

      var arrowOffTop = arrow.offset().top;

      var blueOverlayHeight = blueOverlay.outerHeight();

      var titleDiff = imageOffTop < titleOffBottom ? titleOffBottom - imageOffTop : 0;
      var fullTitleDiff = fullImageOffTop < fullTitleOffBottom ? fullTitleOffBottom - fullImageOffTop : 0;

      var arrowDiff = arrowOffTop < imageOffBottom ? imageOffBottom - arrowOffTop : 0;
      var fullArrowDiff = arrowOffTop < fullImageOffBottom ? fullImageOffBottom - arrowOffTop : 0;

      var fullDiffs = [fullArrowDiff, fullTitleDiff];
      var diffs = [arrowDiff, titleDiff];

      var blueOverlayDiff = (blueOverlayHeight + Math.max.apply(null, fullDiffs) * 2) / blueOverlayHeight;

      // custom numbers for
      // landing-page template
      if (landingPageTemplate) {
        var imageWrapWidth = image[0].getBoundingClientRect().width;
        var blockWidth = page[0].getBoundingClientRect().width;
        var titleXPos = (imageWrapWidth - blockWidth) / 2;

        blueOverlay.css({
          opacity: 1,
          transform: 'scaleY(' + blueOverlayDiff*.8 + ')'
        });
        // title.css('transform', 'translateY(' + (0 - Math.max.apply(null, diffs)) + 'px)');
        title.css('transform', 'translate(0, ' + (0 - Math.max.apply(null, diffs)) + 'px)');
        arrow.css('transform', 'translateY(' + (Math.max.apply(null, diffs)*.5) + 'px)');
        image.css('opacity', 1);
      } else {
        blueOverlay.css({
          opacity: 1,
          transform: 'scaleY(' + blueOverlayDiff + ')'
        });
        title.css('transform', 'translateY(' + (0 - Math.max.apply(null, diffs)) + 'px)');
        arrow.css('transform', 'translateY(' + Math.max.apply(null, diffs) + 'px)');
        image.css('opacity', 1);
      }

		}, function(){
      var page = $(this);

      if (!$(this).parent().hasClass('subpage-callout__page--active')) {
        $(this).find('[style]').removeAttr('style');
      }
		})
	});
})(jQuery);